export default function Go_Output () {
  return (
    <div>
      <h1>Go_Output </h1>
      <p>Output Function</p>
    </div>
  );
}